<template>
  <div>
    <vue-dropzone
      id="dropzone"
      ref="fileUploadDropzone"

      @vdropzone-success="onUploadSuccess"
      @vdropzone-error="onUploadError"

      @vdropzone-drag-enter="onDragStart"
      @vdropzone-drag-over="onDragStart"
      @vdropzone-drag-leave="onDragEnd"
      @vdropzone-drag-end="onDragEnd"

      @vdropzone-file-added="onFileOrFilesAdded"
      @vdropzone-files-added="onFileOrFilesAdded"

      :class="{ highlightDropTarget: isDragging }"

      :options="dropzoneOptions"
      :duplicateCheck="true"

      :useCustomSlot="true"
    >
      <v-layout row wrap style="pointer-events: none">
        <v-flex xs12 text-xs-center style="pointer-events: none">
          <v-icon class="accent--text" x-large style="pointer-events: none">file_upload</v-icon>
        </v-flex>
        <v-flex xs12 text-xs-center style="pointer-events: none">
          <h1 style="pointer-events: none">{{ $t('library.uploadPlaceholder') }}</h1>
        </v-flex>
      </v-layout>
    </vue-dropzone>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  components: {
    vueDropzone,
  },
  data() {
    return {
      isDragging: false,
      dropzoneOptions: {
        url: `${window.api_url}api/media`,
        method: 'post',
        parallelUploads: 4,
        uploadMultiple: true,
        headers: {
            // Authorization header will be set later.
        },
        thumbnailWidth: 150,
        maxFileSize: 2000, // [MB]
        autoQueue: true,
        autoProcessQueue: true,
        NECHODIacceptedFiles: [
          'image/*',
          'audio/*',
          'video/*',
          'text/html',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation',
          'application/vnd.oasis.opendocument.presentation',
          'application/pdf',
        ],
      },
    };
  },
  methods: {
    /* eslint-disable no-unused-vars */
    onDragStart(ev) {
        /*
        console.log('start:');
        console.log(ev);
        */
        this.isDragging = true;
    },
    onDragEnd(ev) {
        /*
        let el = ev.target;
        while (el) {
            if (el.className.includes('vue-dropzone')) return;
            el = el.parentElement;
        }
        console.log('end:');
        console.log(ev);
        */
        this.isDragging = false;
    },
    onUploadSuccess(file, res) {
      this.$refs.fileUploadDropzone.removeFile(file);
      this.$events.fire('refresh-media-table');
    },
    onUploadSuccessMulti(files, res) {
      files.forEach((item, index) => { // eslint-disable-line no-unused-vars
          this.$refs.fileUploadDropzone.removeFile(item);
      });
      this.$events.fire('refresh-media-table');
    },
    onUploadError(file, msg, data) {
      let errMsg;

      setTimeout(() => {
        this.$refs.fileUploadDropzone.removeFile(file);
      }, 3000);

      if (typeof msg === 'string') {
        errMsg = msg;
      } else {
        errMsg = msg.message;
      }
      this.$toasted.show(errMsg, { duration: 3000, singleton: true, type: 'error' });
    },
    onUploadErrorMulti(files, msg, data) {
      let errMsg;

      files.forEach((item, index) => { // eslint-disable-line no-unused-vars
          setTimeout(() => {
            this.$refs.fileUploadDropzone.removeFile(item);
          }, 3000);
      });

      if (typeof msg === 'string') {
        errMsg = msg;
      } else {
        errMsg = msg.message;
      }
      this.$toasted.show(errMsg, { duration: 3000, singleton: true, type: 'error' });
    },
    onFileOrFilesAdded(file) {
        this.isDragging = false;
        // Add authorization token just before upload
        this.$refs.fileUploadDropzone.setOption('headers', {
          Authorization: `Bearer ${localStorage.getItem('access-token')}`,
        });
    },
    /* eslint-enable */
  },
};
</script>

<style scoped>
#dropzone.highlightDropTarget {
  background: #fce4ec linear-gradient(
    -45deg,#fafafa 25%,
    transparent 0,
    transparent 50%,
    #fafafa 0,
    #fafafa 75%,
    transparent 0,
    transparent
  );
  background-size: 40px 40px;
}
#dropzone {
    cursor: pointer;
    border-color: var(--v-primary-base);
    color: var(--v-primary-base)
}
</style>
